import React from 'react';
import { Link } from 'react-router-dom';
import './Dashboard.css';
import bgImage from '../assets/bg.gif';

function Dashboard({ user, onLogout }) {
  return (
    <div className="landing-page">
      {/* Background */}
      <div className="landing-background" style={{backgroundImage: `url(${bgImage})`}}></div>

      {/* Header/Navigation */}
      <nav className="landing-nav">
        <div className="nav-brand">
          <h1>Roll20s</h1>
        </div>
        <div className="nav-user">
          <span className="welcome-text">Welcome, {user.username}</span>
          {user.is_admin && <span className="admin-badge">ADMIN</span>}
          {user.is_admin && (
            <Link to="/admin">
              <button className="btn-nav">Admin Panel</button>
            </Link>
          )}
          <button className="btn-nav btn-logout" onClick={onLogout}>
            Logout
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <div className="landing-content">
        <div className="hero-section">
          <h1 className="hero-title">Welcome to Roll20s Script Repo</h1>
          <p className="hero-subtitle">Premium Script Downloads for Approved Members</p>
        </div>

        {/* Download Sections */}
        <div className="downloads-grid">
          <div className="download-card featured">
            <div className="card-icon">🐉</div>
            <h3>Tameable Creatures Database</h3>
            <p>Browse and compare 241 tameable creatures from UO Outlands</p>
            <Link to="/creatures">
              <button className="btn-download">
                Browse Creatures
              </button>
            </Link>
          </div>

          <div className="download-card">
            <div className="card-icon">📦</div>
            <h3>Script Pack 1</h3>
            <p>Advanced automation scripts for enhanced gameplay</p>
            <button className="btn-download" disabled>
              Coming Soon
            </button>
          </div>

          <div className="download-card">
            <div className="card-icon">🎲</div>
            <h3>Script Pack 2</h3>
            <p>Custom dice rolling and character management tools</p>
            <button className="btn-download" disabled>
              Coming Soon
            </button>
          </div>

          <div className="download-card">
            <div className="card-icon">⚔️</div>
            <h3>Combat Tools</h3>
            <p>Enhanced combat tracking and initiative management</p>
            <button className="btn-download" disabled>
              Coming Soon
            </button>
          </div>

          <div className="download-card">
            <div className="card-icon">🗺️</div>
            <h3>Map Utilities</h3>
            <p>Dynamic lighting and fog of war enhancements</p>
            <button className="btn-download" disabled>
              Coming Soon
            </button>
          </div>

          <div className="download-card">
            <div className="card-icon">📊</div>
            <h3>Character Sheets</h3>
            <p>Custom character sheet templates and macros</p>
            <button className="btn-download" disabled>
              Coming Soon
            </button>
          </div>

          <div className="download-card">
            <div className="card-icon">🎨</div>
            <h3>UI Enhancements</h3>
            <p>Interface customization and theme packs</p>
            <button className="btn-download" disabled>
              Coming Soon
            </button>
          </div>
        </div>

        {/* Info Section */}
        <div className="info-section">
          <div className="info-card">
            <h3>📝 Account Status</h3>
            <p><strong>Username:</strong> {user.username}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Status:</strong> <span className="status-approved">✓ Approved</span></p>
          </div>

          <div className="info-card">
            <h3>📢 Latest Updates</h3>
            <p>• New scripts coming soon!</p>
            <p>• Check back regularly for updates</p>
            <p>• Contact admin for script requests</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="landing-footer">
        <p>&copy; 2024 Roll20s - Premium Scripts for Approved Members Only</p>
      </footer>
    </div>
  );
}

export default Dashboard;
